export const shareButtonData = [
    {
        title: 'facebook',
        url: 'https://www.facebook.com/sharer.php?u=',
        iconUrl: 'assets/icons/facebook.svg'
    },
    {
        title: 'twitter',
        url: 'https://twitter.com/intent/tweet?text=',
        iconUrl: 'assets/icons/twitter.svg'
    },
    {
        title: 'linkedIn',
        url: 'https://www.linkedin.com/shareArticle?mini=true&url=',
        iconUrl: 'assets/icons/linkedin.svg'
    },
    {
        title: 'telegram',
        url: 'https://t.me/share/url?url=',
        iconUrl: 'assets/icons/telegram.svg'
    },
    {
        title: 'whatsapp',
        url: 'https://api.whatsapp.com/send?text=',
        iconUrl: 'assets/icons/whatsapp.svg'
    }
    
]